import { render, staticRenderFns } from "./F203.vue?vue&type=template&id=04b230ce&scoped=true"
import script from "./F203.vue?vue&type=script&lang=js"
export * from "./F203.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=04b230ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b230ce",
  null
  
)

export default component.exports